import { render, staticRenderFns } from "./SettingsPlateformAd.vue?vue&type=template&id=13989436&"
import script from "./SettingsPlateformAd.vue?vue&type=script&lang=js&"
export * from "./SettingsPlateformAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports